export const ART_RESOURCE_TYPE = {
    RESULT: 'RESULT', // 꾸미기 결과 배경
    RESULT_COVER: 'RESULT_COVER', // 꾸미기 결과
    IMAGE: 'IMAGE', // 꾸미기에 사용된 이미지
    LOGO: 'LOGO',   // 꾸미기에 사용된 로고
};

export const ORDER_STATE = {
    WAITING: 'WAITING', // 발주 넣고 확인 전
    RESOLVE: 'RESOLVE', // 발주 확인 완료
    REJECT: 'REJECT',   // 발주 거절 (관리자가 거절)
    CANCEL: 'CANCEL',   // 발주 취소 (넣은 사람이 취소)
    SHIPPING: 'SHIPPING',   // 생산 후 배송 중
    COMPLETE: 'COMPLETE',   // 배송 완료
};